import type { FormStatusTab } from 'src/components/pages/CoiFormManagement/types';
import { ANSWER_TYPES } from 'src/types/formQuestionnaire';
import type { LanguageOption } from 'src/utils/languages';

export type {
  PreviewScreenType,
  QuestionData,
  QuestionOption,
} from 'src/types/formQuestionnaire';

export {
  ANSWER_TYPES,
  API_TYPE_TO_UI_TYPE,
  CHOICE_BASED_TYPES,
  DATA_GRID_COLUMN_TYPE_OPTIONS,
  DATA_GRID_COLUMN_TYPES,
  OPTION_BASED_TYPES,
  PREVIEW_SCREENS,
} from 'src/types/formQuestionnaire';

export const BASE_ANSWER_TYPE_OPTIONS = [
  { label: 'Short text', value: ANSWER_TYPES.SHORT_TEXT },
  { label: 'Long text', value: ANSWER_TYPES.LONG_TEXT },
  { label: 'Single choice', value: ANSWER_TYPES.RADIO },
  { label: 'Multiple choice', value: ANSWER_TYPES.CHECKBOX },
  { label: 'Dropdown - single choice', value: ANSWER_TYPES.DROPDOWN_SINGLE },
  { label: 'Dropdown - multiple choice', value: ANSWER_TYPES.DROPDOWN_MULTI },
  { label: 'Data grid', value: ANSWER_TYPES.DATA_GRID },
  { label: 'Attachment', value: ANSWER_TYPES.ATTACHMENT },
];

export const SPEAK_UP_ADDITIONAL_OPTIONS = [
  { label: 'Date picker', value: ANSWER_TYPES.DATE_PICKER },
  { label: 'Time picker', value: ANSWER_TYPES.TIME_PICKER },
  { label: 'Numeric', value: ANSWER_TYPES.NUMERIC },
  { label: 'Database field', value: ANSWER_TYPES.DATABASE_FIELD },
];

export const ALL_ANSWER_TYPE_OPTIONS = [
  ...BASE_ANSWER_TYPE_OPTIONS,
  ...SPEAK_UP_ADDITIONAL_OPTIONS,
];

export type FormCreationMode = 'initial' | 'loading' | 'content' | 'edit';

export interface CountryOption {
  label: string;
  value: string;
}

export interface DuplicateFromState {
  sourceTitle: string;
  sourceLanguages?: LanguageOption[];
  displayName?: string;
  sourceQuestionnaireId?: string;
  sourceQuestionnaireStatus?: FormStatusTab;
}

export const FORM_ACTIONS = {
  DRAFT: 'draft',
  PUBLISH: 'publish',
  PREVIEW: 'preview',
} as const;

export type FormAction = (typeof FORM_ACTIONS)[keyof typeof FORM_ACTIONS];

export const HEADER_SCROLL_OFFSET = 48;
